import styled from 'styled-components';
import { BaseContainer } from 'styles/sharedStyles';

export const FilterContainer = styled.div`
  background: white;
  border-radius: 5px;
  padding: 8px;
`;

export const Line = styled.hr`
  margin: 0px;
  border-color: rgba(244, 244, 244, 0.3);
`;

export const FilterTitle = styled.div`
  padding: 10px 10px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.94);
`;

export const FilterBody = styled.div`
  padding: 5px 10px;
`;

export const SubCategoryContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SubCategoryItem = styled.div`
  padding: 8px 5px;
  display: flex;
  word-wrap: break-word;
  max-width: 220px;
  font-size: 0.95rem;
  color: rgba(103, 103, 103, 1);
  label {
    font-weight: 400;
    color: rgba(0, 0, 0, 0.64);
  }
`;

export const Checkbox = styled.input`
  margin-right: 4px;
`;

export const CategroyBaseContainer = styled(BaseContainer)`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  cursor: pointer;
`;

export const FilterHeading = styled.div`
  padding: 10px;
  font-weight: 500;
  font-size: 1.4rem;
  background: white;
  border-radius: 5px;
  margin-bottom: 5px;
`;
